import { render, staticRenderFns } from "./And.vue?vue&type=template&id=74e85e9a&scoped=true&"
import script from "./And.vue?vue&type=script&lang=js&"
export * from "./And.vue?vue&type=script&lang=js&"
import style0 from "./And.vue?vue&type=style&index=0&id=74e85e9a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74e85e9a",
  null
  
)

export default component.exports